import {GetterTree, MutationTree, ActionTree} from 'vuex'
import {OverlaysState} from '@/store/types'

type OverlaysGetter = GetterTree<OverlaysState, any>
type OverlaysMutation = MutationTree<OverlaysState>
type OverlaysAction = ActionTree<OverlaysState, any>

const state: OverlaysState = {
  showInventoryNewItemOverlay: false,
  showInventoryEditItemOverlay: false,
  showInventoryItemListOverlay: false,
  showInventoryRoomOverlay: false,
  showInventoryEditRoomOverlay: false,
  showInventoryCustomRoomOverlay: false,
  showInventoryItemList: false,
  showInventoryAddMultipleItemsOverlay: false,
}

const getters: OverlaysGetter = {
  showInventoryNewItemOverlay: (state) => state.showInventoryNewItemOverlay,
  showInventoryEditItemOverlay: (state) => state.showInventoryEditItemOverlay,
  showInventoryItemListOverlay: (state) => state.showInventoryItemListOverlay,
  showInventoryRoomOverlay: (state) => state.showInventoryRoomOverlay,
  showInventoryEditRoomOverlay: (state) => state.showInventoryEditRoomOverlay,
  showInventoryCustomRoomOverlay: (state) => state.showInventoryCustomRoomOverlay,
  showInventoryItemList: (state) => state.showInventoryItemList,
  showInventoryAddMultipleItemsOverlay: (state) => state.showInventoryAddMultipleItemsOverlay,
}

const mutations: OverlaysMutation = {
  setInventoryNewItemOverlay: (state, payload) => {
    state.showInventoryNewItemOverlay = payload
  },
  setInventoryEditItemOverlay: (state, payload) => {
    state.showInventoryEditItemOverlay = payload
  },
  setInventoryItemListOverlay: (state, payload) => {
    state.showInventoryItemListOverlay = payload
  },
  setInventoryRoomOverlay: (state, payload) => {
    state.showInventoryRoomOverlay = payload
  },
  setInventoryEditRoomOverlay: (state, payload) => {
    state.showInventoryEditRoomOverlay = payload
  },
  setInventoryCustomRoomOverlay: (state, payload) => {
    state.showInventoryCustomRoomOverlay = payload
  },
  setInventoryItemList: (state, payload) => {
    state.showInventoryItemList = payload
  },
  setInventoryAddMultipleItemsOverlay: (state, payload) => {
    state.showInventoryAddMultipleItemsOverlay = payload
  },
}

const actions: OverlaysAction = {

}

export default {
  state,
  getters,
  mutations,
  actions,
}
